import React, { useState, useEffect } from "react";
import "./Prices.css";
import Aos from "aos";

const Prices = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  const [header] = React.useState({
    mainHeader: "CHOOSE A PLAN",
    subHeading: "Pricing Plan",
    text:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum standard dummy text.",
  });
  const [state] = React.useState([
    {
      id: 1,
      heading: "Basic",
      price: 50,
      msg1: "2 Page Application",
      msg2: "Using HTML5, CSS3",
      msg3: "Responsive Design",
      msg4: "Standard Code",
      msg5: "1 Revision",
    },
    {
      id: 2,
      heading: "Standard",
      price: 80,
      msg1: "4 Page Application",
      msg2: "Using HTML5, CSS3, JS",
      msg3: "Responsive Design",
      msg4: "Standard Code",
      msg5: "3 Revision",
    },
    {
      id: 3,
      heading: "Premium",
      price: 100,
      msg1: "6 Page Application",
      msg2: "Using HTML5, CSS3, JS, React.js",
      msg3: "Responsive Design",
      msg4: "Standard Code",
      msg5: "5 Revision",
    },
  ]);
  return (
    <div className="container-fluid">
      <div className="prices">
        <div className="container">
          <div className="common">
            <h3 className="heading">{header.mainHeader}</h3>
            <div className="border-about"> </div>
            <h1 className="mainHeader">{header.subHeading}</h1>

            <div className="commonBorder"></div>
          </div>
          <div className="row">
            {state.map((prices) => (
              <div
                className="col-lg-4 col-sm-12 col-sm-12"
                data-aos="fade-up"
                key={prices.id}
              >
                <div className="price">
                  <div className="priceHeading">${prices.heading}</div>
                  <div className="border-about"> </div>
                  <div className="price__rs">
                    <span>$</span>
                    {prices.price}
                  </div>
                  <ul>
                    <li>{prices.msg1}</li>
                    <li>{prices.msg2}</li>
                    <li>{prices.msg3}</li>
                    <li>{prices.msg4}</li>
                    <li>{prices.msg5}</li>
                  </ul>
                  <div className="price__btn">
                    <a href="" className="btn btn-outline">
                      Purchase
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Prices;
